import {SET_ASSESSMENT} from "../actions/assessment";

export default ({action, state = null}) => {
  switch(action.type) {
    case SET_ASSESSMENT:
      return action.assessment ? {...action.assessment} : null;
    default:
      return state;
  }
};
